    <template>
    <div class="vue-dentaid-alert-block" v-if="showPopup">
        <div class="container-fluid extra-outer-padding">
            <div class="row">
                <div class="col-12">
                    <div class="alert mb-0">
                        <div class="content-wrapper">
                            <div class="content" v-html="content">
                            </div>
                            <div class="close-icon">
                                <button aria-label="close alert" @click="handleCloseAlert" class="homepage-alert-close"><span class="visually-hidden">Close</span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DentaidAlertBlock",

    props: ['content'],

    data() {
        return {
            showPopup: false,
        }
    },

    created() {
        if (window.dentaidAlertCookie && !window.dentaidAlertCookie.isAlertDismissed()) {
            this.showPopup = true;
        }
    },

    methods: {
        handleCloseAlert() {
            this.showPopup = false;
            if (window.dentaidAlertCookie) {
                window.dentaidAlertCookie.dismissAlert();
            }
        },
    }
}
</script>

<style scoped>

</style>
